import './CoralBlogArticleTable.scss'

import { Markdown } from '@websrc/App/Components/Markdown/Markdown'
import { mapCoralWebTable } from '@websrc/DataMappers/mapArticleBody'
import React from 'react'

type CoralBlogArticleTableProps = ReturnType<typeof mapCoralWebTable> & {
  applySpotStyling?: boolean
}

export const CoralBlogArticleTable = ({
  columns,
  rows,
  applySpotStyling = false,
}: CoralBlogArticleTableProps) => {
  const columnsAmount = columns.length
  return (
    <div className={applySpotStyling ? 'category-coral-spot' : ''}>
      <div className={'blog-article-table'}>
        <div
          className={'blog-article-table__table'}
          style={{ gridTemplateColumns: `repeat(${columnsAmount}, 1fr)` }}
        >
          {columns.map((colHeader, colIndex) => (
            <div
              className={`blog-article-table__item blog-article-table__head ${
                colIndex === columnsAmount - 1 ? 'blog-article-table__no-right-border' : ''
              }`}
              key={`col-${colIndex}`}
            >
              {colHeader}
            </div>
          ))}
          {rows.map((row, rowIndex) =>
            row.map((cell, colIndex) => (
              <div
                className={`blog-article-table__item blog-article-table__content ${
                  colIndex === columnsAmount - 1 ? 'blog-article-table__no-right-border' : ''
                }`}
                key={`row-${rowIndex}-col-${colIndex}`}
              >
                <Markdown
                  className={'blog-article-table__markdown'}
                  markdown={cell}
                  skipWidth={true}
                />
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  )
}
